// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space_group_items[data-v-4d47a31a]{margin-left:36%}.answer-last-group[data-v-4d47a31a]{width:100%}.space_group_title[data-v-4d47a31a]{position:relative;left:1em}.space_group_item.el-input.el-input--mini[data-v-4d47a31a]{width:48px}", ""]);
// Exports
module.exports = exports;
